/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/27/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */

export default {
  install(Vue) {
    const moduleFiles = require.context(".", true, /(?<!index)\.js$/i);
    for (let key of moduleFiles.keys()) {
      let name = key.match(/\b([^/]+)\.js$/)[1];
      Vue.filter(name, moduleFiles(key).default);
    }
  }
};
